<template>
    <div>
        <el-button @click="edit" type="primary" size="mini">添加注射项目</el-button>
        <div class="el-col el-col-24" style="margin-top: 4px;">
            <div v-for="(domain, index) in childInject " :key="index">
                <div class="font_header  el-row">
                    <div class=" el-col-24">
                        <div class="el-col el-col-12">注射项目名称</div>
                        <div class="el-col el-col-11">送诊护士</div>
                        <div class=" el-col el-col-1">
                            <button type="button" class="el-button el-button--danger el-button--mini is-circle" @click.prevent="remove(domain,index)"><i class="el-icon-minus"></i></button>
                        </div>
                    </div>
                </div>
                <div class="el-row">
                    <div class="pad_10  el-col el-col-24">
                        <div class="el-col el-col-24">
                            <!-- 1耗材名称 -->
                            <div class="el-col el-col-12">
                                <el-input v-model="domain.injectionProjectName" placeholder="请输入注射项目名称"></el-input>
                            </div>
                            <!-- 2耗材规格 -->
                            <div class="el-col el-col-12">
                                <el-select @focus="focus(2)" @keydown.enter.native="enterDoctor($event,2,index)" ref="injectionNurseName" default-first-option :filter-method="aaMatch" v-model="domain.injectionNurseName" clearable placeholder="请选择护士" filterable remote>
                                    <el-option v-for="(item) in newList2" :key="item.id" :label="item.identityName" :value="item.identityName"></el-option>
                                </el-select>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
    props: ['childInject',],
    computed: {
        ...mapGetters(['list2']),
    },
    data() {
        return {
            newList2: [],
        }
    },
    methods: {
        focus(val) {
            if (val == 2) {
                this.newList2 = this.list2
            }
        },
        aaMatch(val) {
            this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
        },
        enterDoctor(e, val, index) {
            if (val == 2) {//护士
                if (this.newList2[0] != undefined) {
                    this.childInject[index].injectionNurseName = this.newList2[0].identityName
                    this.$forceUpdate()
                    this.$refs.injectionNurseName[0].blur()
                }
            }
        },
        // 添加注射项目
        edit() {
            this.childInject.push({
                key: Date.now(),
                injectionProjectName: '',
                injectionProjectAmt: '',
                injectionNurseName: '',
            });
        },
        // 删除注射项目
        remove(item, listIndex) {
            var index = this.childInject.indexOf(item)
            if (index !== -1) {
                this.childInject.splice(listIndex, 1)
            }
        },
    }
}
</script>
<style scoped>
.font_header {
  background-color: #fff7f3;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
}
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>